module.exports = __webpack_public_path__ + "flag-sweden.38858d02.png";